
import React from 'react';
import { CertificatesTableHead } from "./CertificatesTableHead";
import { ResponsiveTable } from 'components/layout/Table/ResponsiveTable';
import { CertificatesTableBody } from './CertificatesTableBody';

function CertificatesTableComponent(props) {

    return (
        <ResponsiveTable>
            <CertificatesTableHead
            shouldRenderFields={props.shouldRenderFields}
            applySort={ props.applySort }
            filters={props.filters}
            applyFilters={props.applyFilters}
             />
            <CertificatesTableBody
            shouldRenderFields={props.shouldRenderFields}
            certificates={props.certificates}
            actionCallback={props.actionCallback}
            />
        </ResponsiveTable>
    )
}

export {CertificatesTableComponent}
